import {
  Listbox as HeadlessListbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import Icon from "./Icon";
import Check from "./icons/check.svg?react";
import KeyboardArrowDown from "./icons/keyboard_arrow_down.svg?react";
import styles from "./Listbox.module.css";

interface Props<T> {
  values: readonly T[];
  value: T;
  formatValue: (v: T) => string;
  onChange: (value: T) => void;
}

const Listbox = <T extends string>({
  values,
  value,
  formatValue,
  onChange,
}: Props<T>) => {
  return (
    <HeadlessListbox
      as="div"
      value={value}
      onChange={(id) => {
        onChange(id);
      }}
    >
      <ListboxButton className={styles.button}>
        {formatValue(value)} <Icon glyph={KeyboardArrowDown} />
      </ListboxButton>
      <ListboxOptions className={styles.options} anchor="bottom end">
        {values.map((v, i) => (
          <ListboxOption
            as="button"
            key={i}
            value={v}
            className={styles.option}
          >
            {({ selected }) => (
              <>
                <span>{formatValue(v)}</span>
                {selected && <Icon glyph={Check} />}
              </>
            )}
          </ListboxOption>
        ))}
      </ListboxOptions>
    </HeadlessListbox>
  );
};

export default Listbox;
